/**
 * The legacy cpanel always queried `/couriers/in-radius` with radius <= 100 km (its
 * "counts" call uses exactly 100000). Larger map viewports (zoomed far out) made the
 * backend answer 403 `out.of.bound`, so every request is clamped into that known-good range.
 */
export const MAX_TRACKING_RADIUS_M = 100_000;
export const MIN_TRACKING_RADIUS_M = 100;

const clamp = (value: number, min: number, max: number) =>
  Math.min(max, Math.max(min, value));

export function normalizeViewport<
  T extends { lat: number; long: number; radius: number },
>(filter: T): T {
  // Wrap only when panned past the antimeridian; avoids float noise on valid longitudes.
  const long =
    filter.long >= -180 && filter.long <= 180
      ? filter.long
      : ((((filter.long + 180) % 360) + 360) % 360) - 180;
  return {
    ...filter,
    lat: clamp(filter.lat, -90, 90),
    long,
    radius: Math.round(
      clamp(filter.radius, MIN_TRACKING_RADIUS_M, MAX_TRACKING_RADIUS_M),
    ),
  };
}
